import Communication from './Communication.view';

export default Communication;
